import useFlag from 'hooks/useFlag'
import { Fields as Merchant } from 'models/Merchant'
import { Col, Row } from 'react-bootstrap-five'
import { getDiscountCategories } from '../../helpers'
import { RedeemTypeItem } from '../../types'
import Category from './Category'

type TypeStepProps = {
  merchant: Merchant | null
  typeItem: RedeemTypeItem | null
  setRedeemType: (typeItem: RedeemTypeItem) => void
}

const TypeStep = ({ merchant, typeItem, setRedeemType }: TypeStepProps) => {
  const baseCategories = getDiscountCategories(!!merchant?.ordering_enabled)
  const freeModifierRewardsEnabled = useFlag('mx-free-modifier-rewards', false)

  const categories = baseCategories.map(category => {
    if (category.key === 'free_item') {
      let items = category.items
      if (
        !freeModifierRewardsEnabled &&
        typeItem?.key !== 'get_a_free_modifier'
      ) {
        items = items.filter(({ key }) => key !== 'get_a_free_modifier')
      }
      // When editing an existing template with the old free-item type, keep
      // showing that option so the selection stays valid.
      const showNewFreeItem = typeItem?.key !== 'get_a_free_item'
      if (showNewFreeItem) {
        items = items.filter(({ key }) => key !== 'get_a_free_item')
      } else {
        items = items.filter(({ key }) => key !== 'free_fixed_price_item')
      }
      return { ...category, items }
    }
    return category
  })

  return (
    <Row className="d-flex justify-content-center">
      <Col lg={6}>
        {categories.map(redeemCategory => (
          <Category
            key={redeemCategory.key}
            redeemCategory={redeemCategory}
            selectedTypeItem={typeItem}
            onItemSelect={setRedeemType}
          />
        ))}
      </Col>
    </Row>
  )
}

export default TypeStep
